import React, { FC } from 'react';

import Schema from '../../../../../../lib/paths/zuwendungsantrag_FULL_Paths.json';
import { useApplication } from '../../../../../../context/ApplicationContext';
import { Typography } from '@mui/material';
import CreateForm from '../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { getFormStrucComponentTable } from '../../../../../../utils/formStruc';
const P = Schema.attributes;

const Zeitplanung: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();

	return (
		<>
			<Typography variant="h3">Zeitplanung</Typography>
			<CreateForm
				formStruc={formStruc}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={readOnly}
			/>
		</>
	);
};
export default Zeitplanung;

const formStruc = [
	{
		fields: [{ ...P.Zeitplanung_Zeitplanung_Block_1, type: 'componentTable', hideColumns: ['Zelle_5'] }],
		userProps: { columnToDivide: 1 },
	},
];

export const GetZeitplannungFormStruc = (application: any) => {
	const formStrucCTWithIndex = getFormStrucComponentTable(application, formStruc);
	return formStrucCTWithIndex;
};
